var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1877.03,
    height: 1294.066,
    viewBox: "0 0 1877.03 1294.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Placeholder",
    transform: "translate(17500.59 -14695.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "alexander-andrews-A3DPhhAL6Zg-unsplash",
    width: 1877.03,
    height: 1294.066,
    transform: "translate(-17500.59 14695.5)",
    fill: "#e2e8f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "photo",
    transform: "translate(-16841.936 15124.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4293",
    "data-name": "Path 4293",
    d: "M524.2,61.2H35.539A35.541,35.541,0,0,0,0,96.739V461.013a35.54,35.54,0,0,0,35.539,35.537H524.2a35.541,35.541,0,0,0,35.541-35.538V96.739A35.54,35.54,0,0,0,524.2,61.2Zm0,35.538V355.2l-70.038-63.677a26.645,26.645,0,0,0-36.773.88L346.5,363.28,206.739,196.337a26.652,26.652,0,0,0-40.639-.275L35.539,347.795V96.739ZM373.159,190.029a48.865,48.865,0,1,1,48.864,48.865A48.859,48.859,0,0,1,373.159,190.029Z",
    transform: "translate(0 -61.201)",
    fill: "#92a5c4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImg);
export default __webpack_public_path__ + "static/media/placeholder_img.799009b39a3e2e799a541bc985bd8afd.svg";
export { ForwardRef as ReactComponent };